/* lyvoi-pilot-entry.js — Lyvoi PDP
 *
 * Adds an "Also available: PILOT" link under the size/quantity selector on the
 * main landing page (/products/aluminium-suitcase). Customers keep emailing that
 * they cannot find the Pilot (Thomas Branscum, 2026-09-16): it only exists as its
 * own product page.
 *
 * The link shows only while the Pilot product is still available. Pilot is not
 * being restocked (2026-09-17), so once it sells out the link disappears by
 * itself instead of sending traffic to a sold-out page. Price comes from the
 * product JSON, never hard-coded.
 *
 * Display only: never touches the add-to-cart form. Any failure = no link.
 */
(function () {
  'use strict';

  var PAGE_RE = /\/products\/aluminium-suitcase\/?$/;
  var PILOT_HANDLE = 'lyvoi-aluminium-suitcase-pilot';
  var ID = 'lyvoi-pilot-entry';

  // 2026-10-16: Pilot out of stock in the warehouse but Shopify still reports
  // available, so hide the link manually. Set to false once restocked.
  var HIDE = true;

  if (HIDE || !PAGE_RE.test(location.pathname)) return;

  function money(cents) {
    var n = cents / 100;
    return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0));
  }

  function render(p) {
    if (document.getElementById(ID)) return;
    var anchor = document.querySelector('quantity-breaks') ||
      document.querySelector('.product-form__input');
    if (!anchor || !anchor.parentNode) return;

    var link = document.createElement('a');
    link.id = ID;
    link.href = '/products/' + PILOT_HANDLE;
    link.style.cssText =
      'display:block;margin:12px 0;padding:10px 14px;border:1px solid currentColor;' +
      'border-radius:6px;text-align:center;text-decoration:none;font-size:14px;line-height:1.4;';
    link.innerHTML = 'Also available: <strong>PILOT</strong> case — ' +
      money(p.price) + ' &rarr;';
    anchor.parentNode.insertBefore(link, anchor.nextSibling);
  }

  function init() {
    fetch('/products/' + PILOT_HANDLE + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && p.available) render(p); })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
